import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import IconIncome from '@mui/icons-material/TrendingUpRounded';
import IconExpense from '@mui/icons-material/TrendingDownRounded';
import IconBalance from '@mui/icons-material/AccountBalanceWalletOutlined';
import { formatCurrency } from '../utils/financeFormat';
import styles from './FinanceSummary.module.css';

/** Entradas, saídas e saldo do período filtrado (totais que a lista já devolve). */
function FinanceSummary({ totals, isLoading }) {
    const income = totals?.income || 0;
    const expense = totals?.expense || 0;
    const balance = totals?.balance ?? income - expense;
    const count = totals?.count || 0;

    const items = [
        { key: 'income', label: 'Entradas', value: income, icon: <IconIncome />, tone: styles.green },
        { key: 'expense', label: 'Saídas', value: expense, icon: <IconExpense />, tone: styles.rose },
        {
            key: 'balance',
            label: 'Saldo',
            value: balance,
            icon: <IconBalance />,
            tone: balance < 0 ? styles.rose : styles.blue,
            hint: `${count} ${count === 1 ? 'lançamento' : 'lançamentos'} no período`
        }
    ];

    return (
        <div className={styles.grid}>
            {items.map(item => (
                <div key={item.key} className={`${styles.card} ${item.tone}`}>
                    <div className={styles.icon}>{item.icon}</div>
                    <div className={styles.texts}>
                        <span className={styles.label}>{item.label}</span>
                        {isLoading ? (
                            <Skeleton variant="text" width={110} height={30} />
                        ) : (
                            <span className={styles.value}>{formatCurrency(item.value)}</span>
                        )}
                        {item.hint && !isLoading && <span className={styles.hint}>{item.hint}</span>}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default FinanceSummary;
